var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformationCircleNewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 25.44 25.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "information-circle",
    d: "M68.72,56A12.72,12.72,0,1,0,81.44,68.72,12.734,12.734,0,0,0,68.72,56Zm0,5.215a1.654,1.654,0,1,1-1.654,1.654A1.654,1.654,0,0,1,68.72,61.215Zm3.053,14.374h-5.6a1.018,1.018,0,1,1,0-2.035h1.781v-5.6H66.939a1.018,1.018,0,1,1,0-2.035h2.035a1.018,1.018,0,0,1,1.018,1.018v6.614h1.781a1.018,1.018,0,1,1,0,2.035Z",
    transform: "translate(-56 -56)",
    fill: "#a9a9a9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircleNewIcon);
export default __webpack_public_path__ + "static/media/information-circle-new-icon.fd1fd33c8affc826824dd7a743e7adb6.svg";
export { ForwardRef as ReactComponent };